module.exports = __webpack_public_path__ + "static/media/image1.9a792c6c.png";